import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
} from '@mui/material'
import type { SyntheticEvent } from 'react'
import { useAuth } from '@/features/auth/hooks/useAuth'
import { debugActions } from '@/features/auth/slice'
import { useAppDispatch } from '@/redux/hooks'

export const ChangeAuthSection = () => {
  const dispatch = useAppDispatch()
  const {
    state: {
      userRights,
      _debugUserRights: { useDebug },
    },
  } = useAuth()

  function handleChange(
    _event: SyntheticEvent<Element, Event>,
    _checked: boolean,
  ): void {
    if (!(_event.target instanceof HTMLInputElement)) return
    const newRights = { useDebug, ...userRights }
    const name = _event.target.name as keyof typeof newRights

    if (name in newRights) {
      newRights[name] = _event.target.checked
    }

    dispatch(debugActions._setDebugUserRights({ ...newRights }))
  }

  return (
    <Box>
      <Typography variant="subtitle2" gutterBottom>
        Auth Override
      </Typography>
      <FormGroup row>
        <FormControlLabel
          onChange={handleChange}
          control={<Checkbox />}
          checked={useDebug}
          label="Debug Auth"
          name="useDebug"
        />
        {useDebug &&
          Object.entries(userRights).map(([k, v]) => (
            <FormControlLabel
              key={k}
              onChange={handleChange}
              control={<Checkbox />}
              checked={v}
              label={k}
              name={k}
            />
          ))}
      </FormGroup>
    </Box>
  )
}
